import { render, staticRenderFns } from "./WorkFloNoteCard.vue?vue&type=template&id=4bf68d58&"
import script from "./WorkFloNoteCard.vue?vue&type=script&lang=js&"
export * from "./WorkFloNoteCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloNoteCard.vue?vue&type=style&index=0&id=4bf68d58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports